import { render } from "./RevenueDistribution.vue?vue&type=template&id=64fe771d"
import script from "./RevenueDistribution.vue?vue&type=script&lang=js"
export * from "./RevenueDistribution.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__